import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { useTheme } from '@mui/material';
import React from 'react';

import { HamburgerMenuItems } from './HamburgerMenuItems';
import { useHamburgerMenuStyles } from './menuStyles/hamburgerMenuStyles';
import { getIcon } from './shared/IconUtils';
import HeaderEnum from './topLevelMenu/headerEnum';
import { TopLevelMenu } from './topLevelMenu/TopLevelMenu';

export function HamburgerMenu() {
  const theme = useTheme();
  const styles = useHamburgerMenuStyles(theme);

  return (
    <TopLevelMenu
      className={`hamburger-menu ${styles.root}`}
      menuListClassName={`hamburger-menu-list ${styles.menuList}`}
      titleEnum={HeaderEnum.HamburgerMenu}
      icon={getIcon(faBars)}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <HamburgerMenuItems />
    </TopLevelMenu>
  );
}
